import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ApprovalList = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "approval-list" */ './approval-list')),
});
